import React from 'react'
import TreeView from '@mui/lab/TreeView'
import TreeItem from '@mui/lab/TreeItem'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import Typography from '@mui/material/Typography'

import useConfiguration from 'hooks/useConfiguration'
import usePrograms from 'hooks/programs/usePrograms'

const JsonTreeView = ({ data, nodeId = 'root', moduleName }) => {
  const { getMetadataDisplay } = useConfiguration()
  const { programs } = usePrograms()

  const formatKey = (key) => {
    return String(key).replace(/_/g, ' ')
  }

  const renderValue = (value, key = '') => {
    if (data?.path === 'program_id' && key === 'value') {
      const program = programs.find((p) => `${p.id}` === `${value}`.trim())
      return program?.name
    }

    if (value === null) return 'null'
    if (typeof value === 'object') return ''
    if (typeof value === 'string')
      return getMetadataDisplay(value, false, moduleName)
    return String(value)
  }

  const renderNode = (key, value, parentNodeId) => {
    const currentId = `${parentNodeId}-${key}`

    if (value === null || typeof value !== 'object') {
      return (
        <TreeItem
          key={currentId}
          nodeId={currentId}
          label={
            <Typography>
              <Typography
                component="span"
                sx={{ fontWeight: 'medium', textTransform: 'capitalize' }}
              >
                {formatKey(key)}
              </Typography>
              : {renderValue(value, key)}
            </Typography>
          }
        />
      )
    }

    return (
      <TreeItem
        key={currentId}
        nodeId={currentId}
        label={
          <Typography>
            <Typography
              component="span"
              sx={{ fontWeight: 'medium', textTransform: 'capitalize' }}
            >
              {formatKey(key)}
            </Typography>
            :
          </Typography>
        }
      >
        {Array.isArray(value)
          ? value.map((item, index) => renderNode(index, item, currentId))
          : Object.entries(value).map(([k, v]) => renderNode(k, v, currentId))}
      </TreeItem>
    )
  }

  return (
    <TreeView
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      sx={{
        height: 'auto',
        flexGrow: 1,
        maxWidth: '100%',
        overflowY: 'auto',
      }}
    >
      {Object.entries(data).map(([key, value]) =>
        renderNode(key, value, nodeId)
      )}
    </TreeView>
  )
}

export default JsonTreeView
